import { gsap } from 'gsap'

// 跑馬燈
export default class InfiniteMarque {
  DOM: { marque: NodeListOf<Element> }
  constructor(payload: { element: NodeListOf<Element> }) {
    this.DOM = {
      marque: payload.element
    }
    this.init()
  }
  init() {
    this.DOM.marque.forEach((marque) => {
      const marqueContent = marque.childNodes[0]
      const contentCloned = marqueContent.cloneNode(true)
      marque.append(contentCloned)
      this.playMarque({
        marque: marque,
        content: marqueContent
      })
      window.addEventListener('resize', (e) => {
        this.playMarque({
          marque: marque,
          content: marqueContent
        })
      })
    })
  }
  playMarque(payload: { marque: any; content: any }) {
    // calculate gap + total distance
    // ! it's 0, but if it needs to be just in case.
    // let gap = parseInt(getComputedStyle(payload.marque).getPropertyValue('column-gap'), 10)
    let gap = 0
    let width = parseInt(getComputedStyle(payload.content).getPropertyValue('width'), 10)

    let distanceToTranslate = -1 * (width + gap)

    gsap.fromTo(
      payload.marque.children,
      { x: 0 },
      { x: distanceToTranslate, duration: 15, ease: 'linear', repeat: -1 }
    )
  }
}
